import React from 'react';
import MemberPlatformHeader from '../components/chrome/header/member_platform_header';
import Header from '../components/chrome/header';
import SimpleHeader from '../components/chrome/simple_header';
import ProviderHeader from '../components/chrome/provider_header';
import AdminHeader from '../components/chrome/admin_header/index_gated';
import { isFeatureEnabled, FEATURES } from './feature_checker';

const getSimpleHeaderPropsForPath = (path) => {
  if (path.includes('report-an-event')) {
    return { returnTo: path, isSticky: false };
  }

  return null;
};

const isPatientType = (profileType) => {
  const patientTypes = ['Patient', 'PatientPartner'];
  return patientTypes.includes(profileType);
};

export const renderHeader = (auth) => {
  const path = window.location.pathname;

  // Post-conversation surveys provide their own page chrome (legacy
  // `.questionnaire_ottr` background for v1, `QuestionWrapper` top bar for v2),
  // so suppress the global header on these paths regardless of auth state.
  // Without this, unauthenticated users opening an emailed survey link would
  // see a duplicate top bar above the v2 design.
  if (path.startsWith('/member/conversation-survey/')) {
    return null;
  }

  const currentUser = auth.getCurrentUser();
  // Handle unauthenticated users
  if (!auth.isLoggedIn()) {
    const simpleHeaderProps = getSimpleHeaderPropsForPath(path);
    return simpleHeaderProps ? <SimpleHeader {...simpleHeaderProps} /> : <Header />;
  }

  const isMentorMatchPath = path.startsWith('/member/mentor-matches/');
  if (isMentorMatchPath && isFeatureEnabled(auth.currentAccount?.(), FEATURES.NEW_UI)) {
    return null;
  }

  // Builder-driven questionnaires render the v2 QuestionWrapper top bar, which
  // replaces the global header.
  const isDynamicQuestionnairePath = path.startsWith('/member/questionnaires');
  if (isDynamicQuestionnairePath && isFeatureEnabled(auth.currentAccount?.(), FEATURES.USE_QUESTIONNAIRE_BUILDER)) {
    return null;
  }

  // Check if currently impersonating by looking for true_user property
  const isImpersonating = currentUser && currentUser.true_user && currentUser.true_user !== null;
  const trueUser = isImpersonating ? currentUser.true_user : null;

  // For UI decisions, use the original super user's profile type if impersonating
  const effectiveUser = trueUser || currentUser;
  const { current_profile_type: profileType } = effectiveUser;

  if (profileType === 'AccountAdmin' || profileType === 'ClinicalUser') {
    return <ProviderHeader />;
  }

  if (profileType === 'SuperUser') {
    return <AdminHeader />;
  }

  if (isPatientType(profileType)) {
    const hideLinks = window.location.pathname.startsWith('/member/mentor-matches/');
    return <MemberPlatformHeader hideLinks={hideLinks} />;
  }

  return <></>;
};

export const shouldHideHeader = (path, isMobile) => {
  const conversationDetailMatch = path.match(
    /^\/member\/conversations\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
  );

  return conversationDetailMatch && isMobile;
};

const isConversationPath = (path) => {
  return path === '/member/conversations' || path.startsWith('/member/conversations/');
};

const isSettingsPath = (path) => {
  return (
    path === '/member/profile/settings' ||
    path === '/member/profile/edit' ||
    path === '/member/settings' ||
    path.startsWith('/member/settings/')
  );
};

export const shouldHideHeaderForNewConversationUi = (path, auth) => {
  return (
    (isConversationPath(path) || isSettingsPath(path)) && isFeatureEnabled(auth?.currentAccount?.(), FEATURES.NEW_UI)
  );
};

export const showLoginButton = (isLoggedIn, isMobile) => {
  return !isLoggedIn && isMobile;
};
